import * as R from 'ramda';
// helpers/constants
import * as G from '../../helpers';
//////////////////////////////////////////////////

export const AUDIT_WIDTH = 1100;

const getBorderStyles = (arr, index) =>
  G.ifElse(
    R.equals(index, arr.length - 1),
    'none',
    `1px solid ${G.getTheme('colors.lightGrey')}`,
  );

export {
  getBorderStyles,
};
